import {
  Flex,
  HeaderContainer,
  HeaderIcon,
  NaviIconBack,
  NaviIconShare,
} from '@banhala/ui-kit';
import React from 'react';
import { useNavigationGoBack } from 'shared/src/hooks';
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';
const ABLYLiveLogo = () => {
  return (
    <Svg width="117" height="20" viewBox="0 0 117 20" fill="none">
      <Path
        d="M107.754 0H81.7933C79.8292 0 78.2371 1.59898 78.2371 3.57143V16.4286C78.2371 18.401 79.8292 20 81.7933 20H107.754C109.718 20 111.31 18.401 111.31 16.4286V3.57143C111.31 1.59898 109.718 0 107.754 0Z"
        fill="#EC0000"
      />
      <Path
        d="M84.6383 13.7504H88.0167V15.7147H82.5045V4.28613H84.6738L84.6383 13.7504Z"
        fill="white"
      />
      <Path d="M89.617 15.7147V4.28613H91.7863V15.7147H89.617Z" fill="white" />
      <Path
        d="M98.1875 4.28613H100.499L97.8319 15.7147H95.6981L93.031 4.28613H95.3425L96.765 11.7861L98.1875 4.28613Z"
        fill="white"
      />
      <Path
        d="M103.913 13.7504H107.434V15.7147H101.744V4.28613H107.256V6.25042H103.913V8.91828L107.078 8.92899V10.8933H103.913V13.7504Z"
        fill="white"
      />
      <Path
        d="M111.31 6.9647L113.385 5.01113C113.638 4.77363 113.764 4.65399 113.906 4.5647C114.095 4.44506 114.304 4.36113 114.525 4.31828C114.69 4.28613 114.863 4.28613 115.209 4.28613H115.666C116.081 4.28613 116.287 4.28613 116.451 4.35399C116.669 4.44506 116.842 4.61828 116.932 4.83792C117 5.0022 117 5.20935 117 5.62542V14.3754C117 14.7915 117 14.9986 116.932 15.1629C116.842 15.3826 116.669 15.5558 116.451 15.6468C116.287 15.7147 116.081 15.7147 115.666 15.7147H115.209C114.863 15.7147 114.69 15.7147 114.525 15.6826C114.304 15.6397 114.095 15.5576 113.906 15.4361C113.764 15.3451 113.638 15.2272 113.385 14.9897L111.31 13.0361V6.9647Z"
        fill="#EC0000"
      />
      <Path
        opacity="0.15"
        d="M111.31 6.9647L113.385 5.01113C113.638 4.77363 113.764 4.65399 113.906 4.5647C114.095 4.44506 114.304 4.36113 114.525 4.31828C114.69 4.28613 114.863 4.28613 115.209 4.28613H115.666C116.081 4.28613 116.287 4.28613 116.451 4.35399C116.669 4.44506 116.842 4.61828 116.932 4.83792C117 5.0022 117 5.20935 117 5.62542V14.3754C117 14.7915 117 14.9986 116.932 15.1629C116.842 15.3826 116.669 15.5558 116.451 15.6468C116.287 15.7147 116.081 15.7147 115.666 15.7147H115.209C114.863 15.7147 114.69 15.7147 114.525 15.6826C114.304 15.6397 114.095 15.5576 113.906 15.4361C113.764 15.3451 113.638 15.2272 113.385 14.9897L111.31 13.0361V6.9647Z"
        fill="url(#paint0_linear_16099_45350)"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.68571 2.14241L0 17.8567H3.67537L5.11386 14.4621H11.6004L13.0389 17.8567H16.7143L10.0286 2.14241H6.68571ZM8.36781 6.81741L10.2935 11.3817H6.42078L8.36781 6.81741Z"
        fill="#1F1F1F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.0745 2.14241V17.8567H52.9878V14.7317H44.7267V2.14241H41.0745Z"
        fill="#1F1F1F"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M66.8251 2.14241L63.3009 7.98705L59.7767 2.14241H55.8328L61.4801 11.6513V17.8567H65.1199V11.6513L70.7672 2.14241H66.8234H66.8251Z"
        fill="#1F1F1F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.6263 13.471C30.6263 14.4049 29.7123 15.1692 28.7806 15.1692H25.0128V11.7138H28.7806C29.7123 11.7138 30.6263 12.4781 30.6263 13.4121V13.471ZM25.0145 4.82991H28.2134C29.1451 4.82991 29.9079 5.5942 29.9079 6.52813V6.58527C29.9079 7.5192 29.1451 8.28348 28.2134 8.28348H25.0145V4.82813V4.82991ZM31.2948 9.62277C31.2842 9.62098 31.2717 9.61741 31.2611 9.61384C31.3126 9.59777 31.4086 9.57634 31.4638 9.5567C33.7326 8.82277 33.5015 6.09777 33.5015 6.09777C33.5015 3.97455 31.5331 2.2317 29.4331 2.15134L25.5213 2.14062H21.3374V17.8531L30.4716 17.8549C32.5875 17.8549 34.3176 16.1263 34.3176 14.0049V13.3871C34.3176 11.5496 33.0178 10.0031 31.2948 9.62277Z"
        fill="#1F1F1F"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_16099_45350"
          x1="111.488"
          y1="10.0004"
          x2="117.178"
          y2="10.0004"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stop-color="#1F1F1F" />
          <Stop offset="1" stopColor="#1F1F1F" stopOpacity="0" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};

export const ShopliveCustomHeader = () => {
  const onPressBack = useNavigationGoBack();

  return (
    <HeaderContainer>
      <Flex.Row flex={1} alignItems={'center'} justifyContent={'space-between'}>
        <Flex.Row flex={1} alignItems={'center'} padding={{ left: 8 }}>
          <HeaderIcon testID={'BackButton'} onPress={onPressBack}>
            <NaviIconBack fill={'content_primary'} />
          </HeaderIcon>
          <ABLYLiveLogo />
        </Flex.Row>

        <Flex.Center padding={{ right: 8 }}>
          <NaviIconShare
            onPress={() => {
              console.log('onPress');
            }}
          />
        </Flex.Center>
      </Flex.Row>
    </HeaderContainer>
  );
};
